module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ShingleTable-9ced65d975735799a4f380cef2988e61.png";